import Tags from '../../services/Tags';
import Helper from '../../helpers/Helper';

export const LOADING_TAGS = 'LOADING_TAGS';
const loadingTags = () => ({
  type: LOADING_TAGS,
});

export const RECEIVE_TAGS = 'RECEIVE_TAGS';
const receiveTags = tags => ({
  type: RECEIVE_TAGS,
  tags,
});

export const getTags = () => {
  return async dispatch => {
    dispatch(loadingTags());

    try {
      const response = await new Tags().get();

      if (response) {
        dispatch(receiveTags(response.data));
      }
      return response;
    } catch (error) {
      return Helper.formatApiErrorResponse({
        response: error.response,
        message: 'Erro ao buscar tags, atualize a página',
      });
    }
  };
};



// WEBPACK FOOTER //
// ./src/store/tags/actions.js